
export default function Billing({client}) {
  	return (
        <>
            <div className="card card-action mb-6">
                <div className="card-header align-items-center">
                    <h5 className="card-action-title mb-0">Metodi di pagamento</h5>
                    {!client.iban && (
                    <div className="card-action-element">
                        <button className="btn btn-primary btn-sm edit-address" type="button">
                            <i className="bx bx-plus bx-xs me-1_5"></i>Aggiungi
                        </button>
                    </div>
                    )}
                </div>
                <div className="card-body">
                    <div className="added-cards">
                    {client.iban && (
                        <div className="cardMaster border p-6 rounded mb-4">
                            <div className="d-flex justify-content-between flex-sm-row flex-column">
                                <div className="card-information">
                                    <span className="badge bg-label-primary me-1">{client.payment_method ? client.payment_method : 'Metodo di pagamento non inserito'}</span>
                                    <div className="d-flex align-items-center mb-2">
                                        <h6 className="mb-0 me-2">{client.fullname}</h6>
                                    </div>
                                    <span className="card-number">{client.iban}</span>
                                </div>
                                <div className="d-flex flex-column text-start text-lg-end">
                                    <div className="d-flex order-sm-0 order-1">
                                        <button className="btn btn-sm btn-label-primary me-4">Modifica</button>
                                        <button className="btn btn-sm btn-label-danger">Cancella</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!client.iban && (
                        <h6 className="card-action-title mb-0">Non inserito</h6>
                    )}
                    </div>
                </div>
            </div>
        </>
	);
}